import * as Sentry from "@sentry/react";
import { Suspense } from "react";
import { Worker } from "@react-pdf-viewer/core";
import { Route, BrowserRouter as Router } from "react-router-dom";
import ReactDOM from "react-dom";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "./styles/index.scss";
import "./locale/i18n";

import { AppProvider } from "./providers";
import Loader from "./components/Loader";
import App from "./App";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL || "",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

ReactDOM.render(
  <Worker workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}>
    <Suspense fallback={<Loader />}>
      <Router>
        <AppProvider>
          <Route path="/" component={App} />
        </AppProvider>
      </Router>
    </Suspense>
  </Worker>,
  document.getElementById("root")
);
